import {
  allSmartCallFlowActionTypes,
  type ISmartCallFlowAction,
  type ISmartCallFlowActionType,
} from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/type'
import { AddButtonStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/AddButton/store/AddButtonStore'
import { type SmartCallFlowBuilderStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder'
import { isHaveParentCallEnds } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/utils/isHaveParentCallEnds.ts'

export const getActions = ({
  getActionById,
  source,
  target,
}: {
  getActionById: SmartCallFlowBuilderStore['getActionById']
  source: string
  target: string
}): ISmartCallFlowActionType[] => {
  const sourceAction = getActionById(source)
  const targetAction = getActionById(target)

  if (!sourceAction || !targetAction) return []
  if (targetAction instanceof AddButtonStore) return []

  const allowedSourceActionListMap: ISmartCallFlowActionType[][] = []

  const getAllowedSourceAction = (
    sourceAction: ISmartCallFlowAction,
    targetAction: ISmartCallFlowAction
  ) => {
    const branchIndex = sourceAction.actionStore.nextIds.indexOf(targetAction.actionStore.id)

    const types: ISmartCallFlowActionType[] =
      sourceAction.actionStore.allowedNextActionsByBranchIndex?.[branchIndex] ||
      sourceAction.actionStore.allowedNextActions ||
      allSmartCallFlowActionTypes

    allowedSourceActionListMap.push(types)
    const parent = getActionById(sourceAction.actionStore.parentId)
    if (parent) {
      getAllowedSourceAction(parent, sourceAction)
    }
  }
  getAllowedSourceAction(sourceAction, targetAction)

  const allowedNextActionsParentsList = allSmartCallFlowActionTypes.filter(
    (type) =>
      allowedSourceActionListMap.every((actions) => actions.includes(type)) &&
      (targetAction.actionStore.allowedBeforeActions || allSmartCallFlowActionTypes).includes(type)
  )

  return allowedNextActionsParentsList.filter((type) =>
    type === 'sendMessage' && sourceAction
      ? isHaveParentCallEnds(sourceAction, getActionById)
      : true
  )
}
